import { IApiEntity } from "./entity.api.interface";

export interface IApiPermission extends IApiEntity {
  idPermission: number
  module: number
  permission: number
}


/**
 * Listado modulos
 */
export enum Modules{
    Users = 10, // Usuarios
    Clients = 20, // Clientes
    Suppliers = 30, // Proveedores
    Locations = 40, // Localizaciones
    Countries = 50, // Paises
    Regions = 60, // Provincias
    Cities = 80, // Localidades
    SettingsValues = 90, // Configuración de valores
    Roles = 100, // Roles
    Reception = 110, // Recepciones
    LocationsZones = 120, // Almacenes/Zonas
    LocationsZonesAreas = 130, // Almacenes/Zonas/Áreas
    ClientsCenters = 140, // Clientes/Centros
    RolesPermissions = 150, // Roles/Permisos
    SuppliersCenters = 160, // Proveedores/Centros
    UsersLocations = 170, // Usuarios/Localizaciones
    UsersRoles = 180, // Usuarios/Roles
    ReceptionBatchesDocumentsGroups = 190, // Recepciones/Grupos de documentos
    ReceptionBatchesDocumentsGroupsDocuments = 200, // Recepciones/Grupos de documentos/Documentos
    ReceptionBatchesDocumentsGroupsComments = 210, // Recepciones/Grupos de documentos/Comentarios
    Products = 220, // Productos
    LocationsProducts = 230, // Productos/Localizaciones
    ClientsProducts = 240, // Productos/Clientes
    ProductionClassification = 250, // Clasificación
    ProductionProduction = 260, // Producción
    ProductionBatches = 270, // Lotes de producción
    ProductionBatchesStatus = 280, // Lotes de producción/Historico de estados
    ProductionBatchesInputsPackagings = 290, // Lotes de producción/Entrada envases
    ProductionBatchesInputsBatches = 300, // Lotes de producción/Entrada lotes
    ProductionBatchesPackagings = 310, // Lotes de producción/Envases
    LocationsClassificationZones = 320, // Localizaciones/Zonas de clasificación
    ClientsProductsCodes = 330, //Clientes/Códigos de productos
    Loads = 340, // Cargas
    LoadsStatus = 350, // Cargas/Historico de estados
    LoadsPackagings = 360, // Cargas/Envases
    LoadsDocuments = 370, //Cargas/Documentos
    LoadsComments = 380, // Caragas/Comentarios
    StatisticsProducts = 390, // Estadísticas de productos
    StatisticsGeoZones = 400, // Estadísticas de GeoZonas
    StatisticsStoragesEntry = 410, // Estadísticas de entradas de almacén
    Geoloc = 420, // Geolocalización
    Pictograms = 430,
    EndPoints = 450, // EndPoints
    Scales = 460, // Básculas
    S3 = 470, // S3
    StatusWorkflows = 480, // workflow de estados
    Inventory = 490, // Inventory
    StatisticsBlockedPackagings = 500, // Estadísticas de envases bloqueados
    PurchaseOrders = 530, // Pedidos
    StatisticsPackagingsInventoryReports = 510, // Estadísticas de inventario de envases
    SalesOrders = 520, // Pedidos de venta
    SuppliersClients = 540, // Proveedores/Clientes destino
    ReceptionBatchesDestinationClients = 550, // Lotes de recepción/Clientes destino
    ParkedWeighings = 560, // Pesajes aparcados
    MarksSeals = 570, // Marcas y Sellos
    MarksSealsGroups = 580, // Grupos de Marcas y Sellos
    MarksSealsGroupsRoles = 590, // Grupos de Marcas y Sellos/Roles
    Containers = 600, // Contenedores
    StatisticsPackagingsInventoryGeoloc = 610, // Estadísticas de inventario de envases por geolocalización
    LocationsBatches = 620, // Puntos de introducción/Lotes
    ProductionBatchesDocumentsGroups = 630, // Lotes de producción/Grupos de documentos
    ProductionBatchesDocumentsGroupsDocuments = 640, // Lotes de producción/Grupos de documentos/Documentos
    ProductionBatchesDocumentsGroupsComments = 650, // Lotes de producción/Grupos de documentos/Comentarios
    MassBatchLabel = 660, //Etiquetado masivo de lotes
    LoadingPoints = 670, // Puntos de carga
  }
  
  /**
  * Listado permisos
  */
  export enum Permissions{
    List = 10, // Consulta
    Add = 20, // Alta
    Edit = 30, // Edición
    PrintLabel = 40, // Imprimir etiqueta
    ListStorages = 50, // Consulta de almacenes
    StatusHistory = 60, //Histórico de estados
    Delete = 70, //Borrado
    ReleaseLocation = 80, //Liberar plaza
    AssignLocation = 90, //Asignar plaza
    Changestatus = 100, //Cambiar estado
    Download = 110, //Descargar
    CancelPackaging = 120, //Anular envase
    ChangeStatus_LineManager = 130, //Cambiar estado (Jefe de línea)
    ChangeStatus_PlantManager = 140, //Cambiar estado (Jefe de planta)
    ChangeStatus_QualityDepartment = 150, //Cambiar estado (Departamento de calidad)
    ChangeStatus_Logistics = 160, //Cambiar estado (Logística)
    ChangeStatus_InventoryManager = 170, //Cambiar estado (Responsable de inventario)
    ChangeStatus_Financial = 180, //Cambiar estado (Financiero)
    ProcessReturn = 190, // Procesar devolución
    RequestInventoryDeletion = 200, // Solicitar baja
    RequestInventoryAddition = 210, // Solicitar alta
    MassiveUpdate = 220, // Actualización masiva
    AssociateBatchPackaging = 230, // Asociar lote/envase con pedido de venta
    RequestAdjustments = 240, // Solicitar ajustes+
    ManageAdjustmentRequests = 250, // Gestionar solicitudes de ajuste+
    SkipRestrictions = 260, // Omitir restricciones
  }
